import script from "./FormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormModal.vue?vue&type=script&setup=true&lang=ts"

import "./FormModal.vue?vue&type=style&index=0&id=886451ba&lang=scss"

const __exports__ = script;

export default __exports__